import type { EventOrderRecord } from '../types';

const hiddenPaymentStatuses = new Set(['pending', 'failed']);
const testMarkerPattern = /(^|[\s._@+-])(test|testing|demo|sample)(?=$|[\s._@+-])/i;
const placeholderEventPattern = /^new\s+victoria(?:'|’)?s\s+place\s+event$/i;

export function isClientVisibleEventOrder(order: EventOrderRecord): boolean {
  if (hiddenPaymentStatuses.has(order.payment_status)) {
    return false;
  }

  if (placeholderEventPattern.test(order.event_title.trim())) {
    return false;
  }

  return ![
    order.purchaser_name,
    order.purchaser_email,
    order.event_title,
    order.ticket_name,
    order.vendor_business_name,
    order.vendor_contact_name,
    order.vendor_email,
  ].some((value) => value && testMarkerPattern.test(value));
}

export function filterClientVisibleEventOrders(orders: EventOrderRecord[]): EventOrderRecord[] {
  return orders.filter(isClientVisibleEventOrder);
}
